import axios, { AxiosRequestConfig } from "axios";
import store from "../vuex/store";
import { getTenantId } from "./AuthService";

export default class GelService {
  getNetworks(
    mbeServiceBusinessId?: number,
    courierBusinessId?: number,
    serviceBusinessId?: number,
    merchantCode?: string,
    weight?: number
  ) {
    const config = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/gel/network",
      params: {
        mbeServiceBusinessId,
        courierBusinessId,
        serviceBusinessId,
        merchantCode,
        weight,
        tenantId: getTenantId()
      }
    } as AxiosRequestConfig;
    return axios
      .request(config)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }
}
